import { DB_DATE_FORMAT } from "@/lib/consts/formats";
import type { DbDateString } from "@openings/api-client";
import dayjs from "dayjs";
import dayjsFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";

dayjs.extend(dayjsFormat);
dayjs.extend(duration);

export const formatDate = (date: Date): DbDateString =>
  dayjs(date).format(DB_DATE_FORMAT) as DbDateString;

export type ErrorResponse = {
  response?: {
    data?: {
      message?: unknown;
      error?: { message?: unknown };
    };
  };
  message?: unknown;
};

// Returns an array of dates between the start and end dates
export const getDatesBetween = (
  startDate: DbDateString,
  endDate: DbDateString
): Date[] => {
  const dates: Date[] = [];
  let currentDate = dayjs(startDate, DB_DATE_FORMAT);
  const end = dayjs(endDate, DB_DATE_FORMAT);

  while (currentDate.isBefore(end) || currentDate.isSame(end)) {
    dates.push(currentDate.toDate());
    currentDate = currentDate.add(1, "day");
  }

  return dates;
};

// For duration in minutes, returns a formatted string like "1 hr 30 mins"
export const formatMinutes = (v: number): string | null => {
  if (!v) return null;

  const duration = dayjs.duration(v, "minutes");
  const hours = duration.hours();
  const minutes = duration.minutes();

  if (hours && minutes) {
    return `${hours} hr${hours > 1 ? "s" : ""} ${minutes} min${
      minutes > 1 ? "s" : ""
    }`;
  } else if (hours) {
    return `${hours} hr${hours > 1 ? "s" : ""}`;
  } else if (minutes) {
    return `${minutes} min${minutes > 1 ? "s" : ""}`;
  } else {
    return "0 mins"; // Optional: You can return an empty string if needed.
  }
};
